// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Seleccionaragenda — llista/taula d'Agenda
   Objectiu: distingir d'un cop d'ull Avisos (taronja) de Tasques
   (blau), i l'Estat de cada registre.
   ============================================================ */

/* ---- Badges de Tipus (Avís / Tasca) ---- */
.Agenda-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
  color: #fff;
}

.Agenda-badge-avis {
  background-color: #FF9933; /* Avís: taronja corporatiu */
}

.Agenda-badge-tasca {
  background-color: #0099CC; /* Tasca: blau corporatiu */
}

/* ---- Comptadors resum sobre la taula (també filtres de tipus) ---- */
.Agenda-resum-comptadors {
  display: flex;
  gap: 8px;
  margin: 6px 0 10px 0;
  align-items: center;
}

button.Agenda-badge {
  cursor: pointer;
  border: 2px solid transparent;
}

button.Agenda-badge.Agenda-badge-inactiu {
  background-color: #fff;
  color: #666;
}

button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-avis {
  border-color: #FF9933;
  color: #c46a10;
}

button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-tasca {
  border-color: #0099CC;
  color: #007399;
}

.Agenda-safata-de {
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #333;
}

/* ---- Accent visual de fila segons Tipus ---- */
.Dashboard-table tbody tr.Agenda-fila-avis,
.dv2-table tbody tr.Agenda-fila-avis {
  border-left: 4px solid #FF9933;
}

.Dashboard-table tbody tr.Agenda-fila-tasca,
.dv2-table tbody tr.Agenda-fila-tasca {
  border-left: 4px solid #0099CC;
}

.Dashboard-table tbody tr.Agenda-fila-avis td:first-child,
.Dashboard-table tbody tr.Agenda-fila-tasca td:first-child,
.dv2-table tbody tr.Agenda-fila-avis td:first-child,
.dv2-table tbody tr.Agenda-fila-tasca td:first-child {
  border-left: none;
}

.dv2-table tbody tr.Agenda-fila-avis td:first-child {
  box-shadow: inset 4px 0 0 #FF9933;
}

.dv2-table tbody tr.Agenda-fila-tasca td:first-child {
  box-shadow: inset 4px 0 0 #0099CC;
}

.dv2-record.Agenda-fila-avis {
  border-left: 4px solid #FF9933;
}

.dv2-record.Agenda-fila-tasca {
  border-left: 4px solid #0099CC;
}

/* ---- Badges d'Estat ---- */
.Agenda-estat-badge {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid transparent;
}

.Agenda-estat-pendent {
  background-color: #fff3cd;
  color: #856404;
  border-color: #ffe08a;
}

.Agenda-estat-encurs {
  background-color: #d1ecf1;
  color: #0c5460;
  border-color: #9fd8e4;
}

.Agenda-estat-finalitzat {
  background-color: #d4edda;
  color: #155724;
  border-color: #a9dcb5;
}

.Agenda-estat-rebutjat {
  background-color: #f8d7da;
  color: #721c24;
  border-color: #edb4ba;
}

.Agenda-estat-desconegut {
  background-color: #e9ecef;
  color: #555;
  border-color: #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/seleccionaragenda.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE,6CAA6C;AAC7C;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,iDAAiD;AACjD;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* ============================================================\r\n   Seleccionaragenda — llista/taula d'Agenda\r\n   Objectiu: distingir d'un cop d'ull Avisos (taronja) de Tasques\r\n   (blau), i l'Estat de cada registre.\r\n   ============================================================ */\r\n\r\n/* ---- Badges de Tipus (Avís / Tasca) ---- */\r\n.Agenda-badge {\r\n  display: inline-block;\r\n  padding: 2px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1.6;\r\n  white-space: nowrap;\r\n  color: #fff;\r\n}\r\n\r\n.Agenda-badge-avis {\r\n  background-color: #FF9933; /* Avís: taronja corporatiu */\r\n}\r\n\r\n.Agenda-badge-tasca {\r\n  background-color: #0099CC; /* Tasca: blau corporatiu */\r\n}\r\n\r\n/* ---- Comptadors resum sobre la taula (també filtres de tipus) ---- */\r\n.Agenda-resum-comptadors {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin: 6px 0 10px 0;\r\n  align-items: center;\r\n}\r\n\r\nbutton.Agenda-badge {\r\n  cursor: pointer;\r\n  border: 2px solid transparent;\r\n}\r\n\r\nbutton.Agenda-badge.Agenda-badge-inactiu {\r\n  background-color: #fff;\r\n  color: #666;\r\n}\r\n\r\nbutton.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-avis {\r\n  border-color: #FF9933;\r\n  color: #c46a10;\r\n}\r\n\r\nbutton.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-tasca {\r\n  border-color: #0099CC;\r\n  color: #007399;\r\n}\r\n\r\n.Agenda-safata-de {\r\n  font-weight: 600;\r\n  margin: 0 0 8px 0;\r\n  color: #333;\r\n}\r\n\r\n/* ---- Accent visual de fila segons Tipus ---- */\r\n.Dashboard-table tbody tr.Agenda-fila-avis,\r\n.dv2-table tbody tr.Agenda-fila-avis {\r\n  border-left: 4px solid #FF9933;\r\n}\r\n\r\n.Dashboard-table tbody tr.Agenda-fila-tasca,\r\n.dv2-table tbody tr.Agenda-fila-tasca {\r\n  border-left: 4px solid #0099CC;\r\n}\r\n\r\n.Dashboard-table tbody tr.Agenda-fila-avis td:first-child,\r\n.Dashboard-table tbody tr.Agenda-fila-tasca td:first-child,\r\n.dv2-table tbody tr.Agenda-fila-avis td:first-child,\r\n.dv2-table tbody tr.Agenda-fila-tasca td:first-child {\r\n  border-left: none;\r\n}\r\n\r\n.dv2-table tbody tr.Agenda-fila-avis td:first-child {\r\n  box-shadow: inset 4px 0 0 #FF9933;\r\n}\r\n\r\n.dv2-table tbody tr.Agenda-fila-tasca td:first-child {\r\n  box-shadow: inset 4px 0 0 #0099CC;\r\n}\r\n\r\n.dv2-record.Agenda-fila-avis {\r\n  border-left: 4px solid #FF9933;\r\n}\r\n\r\n.dv2-record.Agenda-fila-tasca {\r\n  border-left: 4px solid #0099CC;\r\n}\r\n\r\n/* ---- Badges d'Estat ---- */\r\n.Agenda-estat-badge {\r\n  display: inline-block;\r\n  padding: 2px 9px;\r\n  border-radius: 10px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.Agenda-estat-pendent {\r\n  background-color: #fff3cd;\r\n  color: #856404;\r\n  border-color: #ffe08a;\r\n}\r\n\r\n.Agenda-estat-encurs {\r\n  background-color: #d1ecf1;\r\n  color: #0c5460;\r\n  border-color: #9fd8e4;\r\n}\r\n\r\n.Agenda-estat-finalitzat {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n  border-color: #a9dcb5;\r\n}\r\n\r\n.Agenda-estat-rebutjat {\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n  border-color: #edb4ba;\r\n}\r\n\r\n.Agenda-estat-desconegut {\r\n  background-color: #e9ecef;\r\n  color: #555;\r\n  border-color: #ddd;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
